import { render, staticRenderFns } from "./index.vue?vue&type=template&id=47fbdd7d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=47fbdd7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fbdd7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47fbdd7d')) {
      api.createRecord('47fbdd7d', component.options)
    } else {
      api.reload('47fbdd7d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=47fbdd7d&scoped=true&", function () {
      api.rerender('47fbdd7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/stat/otwoo0102/index.vue"
export default component.exports